import React from "react";

// import navigation data
import { navigation } from "../data";

// import Link
import { Link } from "react-scroll";

import sandeepResume from "../assets/img/Sandeep-Yadav-CV.pdf";

const Nav = () => {
  return (
    <nav>
      <ul className="flex space-x-8 capitalize text-[15px]">
        {navigation.map((item, idx) => {
          return (
            <li
              className="text-white hover:text-accent cursor-pointer"
              key={idx}
            >
              <Link
                to={item.href}
                activeClass="active"
                spy={true}
                smooth={true}
                duration={500}
                offset={-70}
                className="transition-all duration-300"
              >
                {item.name}
              </Link>
            </li>
          );
        })}
        <a href={sandeepResume} target="_blank" download="" rel="noreferrer">
          <li
            onClick={() =>
              window.open(
                "https://drive.google.com/file/d/11bwVCOUbEGCgrZfs_QQG29k7VVp21hC5/view?usp=sharing",
                "_blank"
              )
            }
            className="text-white hover:text-accent cursor-pointer"
          >
            Resume
          </li>
        </a>
      </ul>
    </nav>
  );
};

export default Nav;
